import { createContext, useContext } from 'react';

const defaultLayoutContext = {
  createdAt: 0,
  updatedAt: 0,
  contentType: 'default',
  containsDonationHero: false,
  removeFooterMargin: false,
  showQuickExitButton: false,
};

const LayoutContext = createContext(defaultLayoutContext);

export default LayoutContext;

export const useLayout = () => useContext(LayoutContext);
